export default __webpack_public_path__ + "static/media/hotg.130dfe04.png";